<template>
  <div>
    <b-card class="surrounding-card" :style="backgroundStyle">
      <b-card no-body class="mb-1" style="border-radius: 16px 16px 16px 16px;">
        <b-card-header><h5 class="my-auto">Usage</h5></b-card-header>
        <b-card-body class="my-n3">
          <CDataTable
              hover
              striped
              :items="items"
              :fields="fields"
              :items-per-page-select="{ label: 'Rows per page', values: [10, 20, 50, 100] }"
              :items-per-page="20"
              :pagination="{ doubleArrows: false, align: 'center'}"
              class="table-sm"
              sorter
              :loading="loading"
              add-table-classes="table-bordered wide-table"
              cleaner
          >
            <template #acctstarttime="{item}">
              <td class="py-2">                
                {{item.acctstarttime}}                
              </td>
            </template>
            <template #acctstoptime="{item}">
              <td class="py-2">
                {{item.acctstoptime}}                
              </td>              
            </template>
            <template #acctupdatetime="{item}">
              <td class="py-2">
                {{item.acctupdatetime}}
              </td>
            </template>
            <template #acctinputoctets="{item}">
              <td class="py-2">
                {{item.acctinputoctets}}
              </td>
            </template>
            <template #upbytes="{item}">
              <td class="py-2">
                {{item.upbytes}}
              </td>
            </template>
            <template #site="{item}">
              <td class="py-2">
                {{item.site.name}}
              </td>
            </template>
          </CDataTable>
        </b-card-body>
      </b-card>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { productColor } from '../../helpers/functions'

export default {
  name: 'Usage',
  props: {
    account: {
      type: Object
    },        
  },
  data: () => ({
    items: [],
    fields: [
      { key: 'acctstarttime', label: 'Started', _classes: 'font-weight-bold' },
      { key: 'acctstoptime', label: 'Ended' },
      { key: 'acctupdatetime', label: 'Last Update' },
      { key: 'upbytes', label: 'Upload' },
      { key: 'downbytes', label: 'Download' },
      { key: 'site', label: 'Site' }
    ],
    activePage: 1,
    loading: true
  }),
    computed: {
      ...mapGetters({
        subscription: "plan/getSubscription",
        activeproduct: "plan/getActiveProduct"
      }),
      backgroundStyle() {
        if (this.subscription && this.subscription.product && this.subscription.product.productid) {
          const color = productColor(this.subscription.product.productid);
          return `background: linear-gradient(to right top, #5f135f 35%, ${color} 55%); border-radius: 16px 16px 16px 16px; background-origin: border-box;`;
        } else if (this.account && this.account.flexiplan && this.account.flexiplan.product && this.account.flexiplan.product.productid) {
          const color = productColor(this.account.flexiplan.product.productid);
          return `background: linear-gradient(to right top, #5f135f 35%, ${color} 55%); border-radius: 16px 16px 16px 16px; background-origin: border-box;`;
        }
        return `background: linear-gradient(to right top, #5f135f 35%, #471747 52%); border-radius: 16px 16px 16px 16px; background-origin: border-box;`;
      }
    },
  created: function() {
    this.$portalapi.get('/myaccount/sessions').then((response) => {
        this.loading = false
        this.items = response.data.map(item => { 
          let flatitem = item
          //flatitem['providerid'] = item.benchmarkPK.providerid
          //flatitem['benchmarkid'] = item.benchmarkPK.benchmarkid 
          return flatitem
        }).sort((a, b) => {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.acctstarttime) - new Date(a.acctstarttime);
        });
      })
      .catch((error) => {
        this.loading = false
        this.$log.onError('error fetching usage')
      })
  }
}
</script>

<style scoped>

  .surrounding-card {
    border-radius: 16px 16px 16px 16px;
    box-shadow: 28px 24px 12px 6px grey;
    border: none;
  }

  .card-header:first-child {
    border-radius: 2rem 2rem 0 0;
  }

  .wide-table {
    width: 90%;
  }

  .create-btn {
    float: right;
    color: darkblue;
    font-weight: bold;
  }

  .create-btn:hover {
    color: grey;
  }

  </style>
